var tabsExist = document.querySelector('.tab_tabs');

if (tabsExist) {
    if (typeof NodeList.prototype.forEach !== 'function') {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    window.addEventListener('DOMContentLoaded', () => {
        var tabList = document.querySelector('.tablist[role="tablist"]');
        var tabs = document.querySelectorAll('button.tab[role="tab"]');
        var tabPanels = document.querySelectorAll('.tabpanel[role="tabpanel"]');
        var panelTitleTabs = document.querySelectorAll('.panel-title');

        for (var j = 0; j < tabPanels.length; j++) {
            tabPanels[j].setAttribute('hidden', 'true');
            tabs[j].removeAttribute('hidden');
            panelTitleTabs[j].setAttribute('hidden', 'true');
        }

        tabs[0].setAttribute('aria-selected', 'true');
        tabs[0].setAttribute('tabindex', 0);
        tabs[0].className += ' active';
        tabPanels[0].removeAttribute('hidden');

        // Add a click event handler to each tab
        tabs.forEach(tab => {
            tab.addEventListener('click', changeTabs);
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        tabList.addEventListener('keydown', e => {
            const target = e.target;
            const parent = target.parentNode;
            const grandparent = parent.parentNode;

            // Move right
            if (e.keyCode === 39 || e.keyCode === 37) {
                tabs[tabFocus].setAttribute('tabindex', -1);
                parent
                    .querySelectorAll('.tab[aria-selected="true"]')
                    .forEach(function (t) {
                        t.setAttribute('aria-selected', false);
                        t.classList.remove('active');
                    });
                tabs[tabFocus].setAttribute('aria-selected', true);
                tabs[tabFocus].className += ' active';
                grandparent
                    .querySelectorAll('.tabpanel[role="tabpanel"]')
                    .forEach(p => p.setAttribute('hidden', true));

                if (e.keyCode === 39) {
                    tabFocus++;

                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.keyCode === 37) {
                    tabFocus--;

                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }

                tabs[tabFocus].setAttribute('tabindex', 0);
                parent
                    .querySelectorAll('.tab[aria-selected="true"]')
                    .forEach(function (t) {
                        t.setAttribute('aria-selected', false);
                        t.classList.remove('active');
                    });
                tabs[tabFocus].setAttribute('aria-selected', true);
                tabs[tabFocus].className += ' active';
                grandparent.parentNode
                    .querySelector(`#${tabs[tabFocus].getAttribute('aria-controls')}`)
                    .removeAttribute('hidden');
                tabs[tabFocus].focus();
            }
        });
    });

    function changeTabs(e) {
        const target = e.target;
        const parent = target.parentNode;
        const grandparent = parent.parentNode;

        // Remove all current selected tabs
        parent
            .querySelectorAll('.tab[aria-selected="true"]')
            .forEach(function (t) {
                t.setAttribute('aria-selected', false);
                t.classList.remove('active');
            });

        // Set this tab as selected
        target.setAttribute('aria-selected', true);
        target.className += ' active';

        // Hide all tab panels
        grandparent
            .querySelectorAll('.tabpanel[role="tabpanel"]')
            .forEach(p => p.setAttribute('hidden', true));

        // Show the selected panel
        grandparent.parentNode
            .querySelector(`#${target.getAttribute('aria-controls')}`)
            .removeAttribute('hidden');
    }
}